/* Fütterungsrechner: reine Berechnung plus DOM-Anbindung für die Section bv-ingredients. */
(function (root) {
  // Berechnet Tagesdosis, Messlöffel und Reichweite je Packungsgröße
  function computeFeeding(opts) {
    var weight = Number(opts.weightKg);
    if (!isFinite(weight) || weight <= 0) return null;
    var perHundred = Number(opts.gramsPer100Kg);
    if (!isFinite(perHundred) || perHundred <= 0) return null;
    var factor = Number(opts.factor) || 1;
    var scoop = Number(opts.scoopGrams) || 15;
    var daily = Math.round((weight / 100) * perHundred * factor);
    var scoops = Math.round((daily / scoop) * 2) / 2;
    var packs = (opts.packSizes || []).map(function (g) {
      return { grams: Number(g), days: daily > 0 ? Math.floor(Number(g) / daily) : 0 };
    });
    return { dailyGrams: daily, scoops: scoops, packs: packs };
  }

  // Bindet Eingabefelder und Ergebnisfeld einer Rechner-Instanz
  function bind(el) {
    if (el.dataset.bvBound) return;
    el.dataset.bvBound = '1';
    var cfg = {
      gramsPer100Kg: parseFloat(el.dataset.gramsPerHundredKg),
      scoopGrams: parseFloat(el.dataset.scoopGrams),
      packSizes: (el.dataset.packSizes || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return n > 0; })
    };
    var weightInput = el.querySelector('[data-bv-weight]');
    var factorSelect = el.querySelector('[data-bv-factor]');
    var out = el.querySelector('[data-bv-result]');
    function render() {
      // Deutsche Dezimaltrennzeichen (Komma) in Eingaben zulassen
      var weightValue = String(weightInput.value).replace(',', '.');
      var factorValue = String(factorSelect.value).replace(',', '.');
      var r = computeFeeding({ weightKg: weightValue, factor: factorValue, gramsPer100Kg: cfg.gramsPer100Kg, scoopGrams: cfg.scoopGrams, packSizes: cfg.packSizes });
      if (!r) { out.textContent = el.dataset.textInvalid; return; }
      var scoopsText = String(r.scoops).replace('.', ',');
      var packText = r.packs.map(function (p) { return p.grams + ' g ' + el.dataset.textLasts + ' ' + p.days + ' ' + el.dataset.textDays; }).join(' · ');
      out.innerHTML = '<strong>' + el.dataset.textDaily + ' ' + r.dailyGrams + ' g</strong> (' + scoopsText + ' ' + el.dataset.textScoops + ')<br>' + packText;
    }
    weightInput.addEventListener('input', render);
    factorSelect.addEventListener('change', render);
    render();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeFeeding: computeFeeding };
  } else {
    root.BVFeedingCalculator = { computeFeeding: computeFeeding, bind: bind };
    document.querySelectorAll('[data-bv-calculator]').forEach(bind);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-bv-calculator]').forEach(bind);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
